import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import myformat from "dateformat";

export const ReviewSModal = ({ reviews, name }) => {
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	return (
		<div>
			<p className="btn" onClick={() => handleShow()}>
				Read More ....
			</p>
			<Modal
				show={show}
				onHide={handleClose}
				// backdrop="static"
				dialogClassName="modal-width"
				keyboard={false}
				className="margin-top"
				// fullscreen={true}
				aria-labelledby="example-modal-sizes-title-lg"
			>
				<Modal.Header closeButton>
					<Modal.Title id="example-modal-sizes-title-lg">
						Reviews For <b>{name} </b>{" "}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{reviews.map((comment) => (
						<div className="review-box-1" key={comment?._id}>
							<p className="review-comments">
								<span>
									<b>Comment:</b>{" "}
								</span>
								{comment.review}
							</p>
							<p>
								<b>Rating:</b> <span color="brown">{comment.rating}/5</span>{" "}
							</p>
							<p>
								<b>By:</b> <span>{comment.author?.username}</span>{" "}
							</p>
							<li>
								<span className="mx-3">
									{myformat(comment?.createdAt, "mmmm dS, yyyy, h:MM:ss TT")}
								</span>
							</li>
						</div>
					))}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => handleClose()}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};
